import { FC, useState, useEffect } from "react";
import { useSaleChannelStore } from "../../hooks/useSaleChannelStore";
import { SaleChannel } from "../../types/slices/saleChannelType";
import { Breadcrumbs, Grid } from '@mui/material';
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { SalesChannelsModal } from "./components/SalesChannelsModal";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { CustomBreadcrumb } from "../../components/common/CustomBreadcrumb/CustomBreadcrumb";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'detail', field: 'detail', label: 'Acciones', align:'center' },
]

export const SalesChannels:FC = () => {
    const navigate = useNavigate()
    const { salesChannels, getSalesChannels, deleteSaleChannel, setEditSaleChannel, setActionSaleChannel } = useSaleChannelStore()

    const [loading, setLoading] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false)
    const [rowSelected, setRowSelected] = useState<any>('')
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [searchTimeout, setSearchTimeout] = useState<any>(null)
    const [search, setSearch] = useState<string>('')

    useEffect(() => {
        getSalesChannelssApi()
    }, [])
    
    useEffect(()=>{
        getSalesChannelssApi()
    }, [search])

    const getSalesChannelssApi = async () => {
        setLoading(true)
        let payload:any = {}
        if (search !== '') {
            payload = {
                search
            }
        }
        await getSalesChannels(payload)
        setLoading(false)
    }

    const onAdd = () => {
        setEditSaleChannel({} as SaleChannel)
        setActionSaleChannel('')
        setShowModal(true)
    }

    const onEdit = (rowSelected:any) => {
        setActionSaleChannel('')
        setRowSelected(rowSelected)
        setEditSaleChannel(rowSelected)
        setShowModal(true)
    }

    const onDelete = (rowSelected:any) => {
        setActionSaleChannel('')
        setRowSelected(rowSelected)
        setShowModalConfirm(true)
    }

    const onDeleteConfirm = async () => {
        setLoading(true)
        setShowModalConfirm(false)
        await deleteSaleChannel(rowSelected.id)
            
        setLoading(false)
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => {setSearch(term)}, 1000)
        )
    }

    const onSwitch = () => {

    }

    return (<>
        <Breadcrumbs aria-label="breadcrumb" sx={{mt:3}}>
            <CustomBreadcrumb label={"Maestros"} />
            <CustomBreadcrumb label={"Canales de venta"}
                onClick={() => {
                    navigate({ pathname: RoutesMap.SALE_CHANNEL })
                }}
            />
        </Breadcrumbs>
        <Grid item xs={12}>
            <CustomTable 
                title={'Canales de venta'}
                columns={columns} 
                loading={loading}
                rows={salesChannels || []}
                onRowClick={() => {}}
                hasOptions
                onAddFn={onAdd}
                onAddFnName={'Nuevo canal de venta'}
                onSwitch={onSwitch}
                onDelete={onDelete}
                onEdit={onEdit}
                onSearch={onSearch}
                dense
            />
        </Grid>
        {
            showModal && (
                <SalesChannelsModal
                    open = {showModal}
                    closeModal = {() => {setShowModal(false)}}
                    categorySelected = {rowSelected}
                    onList = {() => getSalesChannelssApi()}
                    // clearState = {clearState}
                />
            )
        }
        {
            showModalConfirm && (
                <ModalConfirm
                    open={showModalConfirm}
                    closeModal={()=>{ setShowModalConfirm(false)}}
                    onConfirm={onDeleteConfirm}
                    status={loading}
                    // clearState = {clearState}
                />
            )
        }
    </>)
}